import { routeTree } from '../../lib';
import { BankingRoutes } from './Banking';
import { CheckoutRoutes } from './Checkout';
import { CRMRoutes } from './CRM';
import { DigitalSigningRoutes } from './DigitalSigning';
import { ExternalRoutes } from './External';
import { IcatuCapRoutes } from './IcatuCap';
import { InsurancesRoutes } from './Insurances';
import { ListingsRoutes } from './Listings';
import { MilesRoutes } from './Miles';
import { uuid } from './regex';
import { RentAdvanceRoutes } from './RentAdvance';
import { RentalRoutes } from './Rental';
import { ScreeningsRoutes } from './Screenings';
import { SettingsRoutes } from './Settings';

const tree = {
    path: '/:workspaceAlias(\\d+)?',
    mfa: {
        path: 'mfa/:token',
    },
    ia: {
        path: 'ia::token',
    },
    recover: {
        path: 'recover',
    },
    reset: {
        path: 'reset/:token',
    },
    tokenAccess: {
        path: 'tokenAccess/:token',
    },
    unsubscribe: {
        path: 'unsubscribe/:token',
    },
    signin: {
        path: 'signin',
    },
    googleAuth: {
        path: 'googleAuth',
    },
    signup: {
        path: 'signup',
    },
    email: {
        path: 'email',
        verify: {
            path: 'verify',
        },
    },
    faqCap: {
        path: 'cap-bond',
    },
    faqInsurance: {
        path: 'insurances',
    },
    workspace: {
        path: 'workspace',
        activate: {
            path: 'activate',
        },
    },
    invite: {
        path: 'invite',
        accept: {
            path: `accept/:inviteId(${uuid})`,
        },
    },
    sign: {
        path: `sign/:contractId(${uuid})`,
        check: {
            path: 'check',
        },
        signer: {
            path: `:signerId(${uuid})`,
            signers: {
                path: 'signers',
            },
            signature: {
                path: 'signature',
            },
            check: {
                path: 'check',
            },
            document: {
                path: `document/:documentId(${uuid})`,
            },
            error: {
                path: 'error',
                expired: { path: 'expired' },
                alreadySigned: { path: 'already_signed' },
            },
        },
        signedDocuments: {
            path: 'documents',
            error: {
                path: 'error',
                expiredDownload: { path: 'expired_download' },
            },
            document: {
                path: `:documentId(${uuid})`,
            },
        },
    },
    validate: {
        path: 'validate',
        document: {
            path: 'document',
        },
        generatePassword: {
            path: 'generatePassword',
        },
        byPassword: {
            path: 'byPassword',
        },
    },
    changeWorkspace: {
        path: 'changeWorkspace',
    },
    invoices: {
        path: 'invoices',
        current: {
            path: 'current',
        },
        details: {
            path: `:invoiceId(${uuid})`,
        },
    },
    survey: {
        path: 'survey',
        purchase: {
            path: 'purchase',
        },
    },
    freeTrial: {
        path: 'freeTrial',
        black: { path: 'black' },
        prime: { path: 'prime' },
        token: { path: ':token([a-z0-9]+)' },
    },
    referral: {
        path: 'referral',
        code: { path: 'code/:inviteCode' },
        invite: { path: 'invite' },
        statement: { path: 'statement' },
        settings: { path: 'settings', verification: { path: 'verification' } },
        kyc: {
            path: 'kyc',
            fill: {
                path: 'fill',
            },
            notOwner: {
                path: 'notOwner',
            },
        },
        withdrawal: { path: 'withdrawal' },
    },
    setup: {
        path: 'setup',
    },
    cap: IcatuCapRoutes,
    listings: ListingsRoutes,
    digitalSigning: DigitalSigningRoutes,
    insurances: InsurancesRoutes,
    screenings: ScreeningsRoutes,
    checkout: CheckoutRoutes,
    settings: SettingsRoutes,
    miles: MilesRoutes,
    rental: RentalRoutes,
    banking: BankingRoutes,
    external: ExternalRoutes,
    crm: CRMRoutes,
    rentAdvance: RentAdvanceRoutes,
};

export default routeTree<typeof tree>(tree);
